module.exports = __webpack_public_path__ + "img/capa-hover-direito.eb70a263.png";